import { all, call, put, takeLatest, select } from 'redux-saga/effects'
import TagAction, { TagTypes } from 'Redux/TagRedux'

export function* getAll(api, action) {
  const resp = yield call(api.getTags, action.params)
  if (resp.ok) {
    yield put(TagAction.tagsListSuccess(resp.data))
  } else {
    yield put(TagAction.tagsListFailure('something went wrong'))
  }
}

export function* onCreate(api, action) {
  const resp = yield call(api.createTag, action.params)
  if (resp.ok) {
    yield put(TagAction.tagsCreateSuccess(resp.data))
    action.callback()
  } else {
    yield put(TagAction.tagsCreateFailure('something went wrong'))
    action.callback()
  }
}

export function* deleteTag(api, action) {
  const resp = yield call(api.deleteTag, action.id)
  if (resp.ok) {
    yield put(TagAction.tagsDeleteSuccess())
    action.callback()
  } else {
    yield put(TagAction.tagsDeleteFailure())
    action.callback()
  }
}

export default function* authSagas(api) {
  yield all([
    takeLatest(TagTypes.TAGS_LIST_REQUEST, getAll, api),
    takeLatest(TagTypes.TAGS_CREATE_REQUEST, onCreate, api),
    takeLatest(TagTypes.TAGS_DELETE_REQUEST, deleteTag, api),
  ])
}
